var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.0163,
    cy: 16.7095,
    rx: 16.0163,
    ry: 15.7173,
    fill: "#FF1C26",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2819_361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0171 11.4746V21.9528",
    stroke: "#FF1C26",
    strokeWidth: 1.684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6782 16.7129H21.3558",
    stroke: "#FF1C26",
    strokeWidth: 1.684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2819_361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3043,
    height: 17.9627,
    fill: "white",
    transform: "translate(6.86475 7.73047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.46c711913f326872da15eb083c5aa269.svg";
export { ForwardRef as ReactComponent };